import CompanyPickScreen from './CompanyPickScreen';

export default CompanyPickScreen;
